import bowser from 'yola-bowser';
import canBeSimpleEdited from '../../../../constraints/verifiers/can-be-simple-edited';

const getContenteditableAttributeValue = (node) => {
  // it is needed to disable the native rich text editing controls for apple touch devices
  // https://github.com/yola/production/issues/8199
  // (it should not be applied for firefox browser because it does not support 'plaintext-only' value)
  if ((bowser.ios || bowser.iPadOS) && !bowser.firefox && canBeSimpleEdited(node)) {
    return 'plaintext-only';
  }

  return 'true';
};

export default getContenteditableAttributeValue;
